import utils from '../utils';

const handleAddToBox = {
	init(section) {

		if ( ! section ) return;

		const addToBox = section.querySelectorAll('.document_row__icons__single--box');

		addToBox.forEach( button => {
			button.addEventListener('click', (event) => {
				event.preventDefault();

				if ( button.classList.contains('external-disabled') ) {
					return;
				}

				const parent = button.closest('.document_row');
				const attachments = [parent.getAttribute('data-id')];
				this.addToBox(attachments, 'boxed_documents');
			});
		});

		this.updateBadgeCount();

		setInterval(() => {
			this.updateBadgeCount();
		}, 500);
	},

	updateBadgeCount() {
		const cookieDocuments = utils.getCookie('boxed_documents');
		const cookieVariants = utils.getCookie('product_variants');

		const itemsCookieDocuments = cookieDocuments ? cookieDocuments.split(',') : [];
		const itemsCookieVariants = cookieVariants ? JSON.parse(cookieVariants) : [];

		length = itemsCookieDocuments.length + itemsCookieVariants.length;

		this.updateHeaderBoxQuantity(length);
	},

	addToBox(newValues, cookieName) {
		const COOKIE_PRODUCT_VARIANTS = 'product_variants';
		const COOKIE_BOXES_DOCUMENTS = 'boxed_documents';

		const cookieDocuments = utils.getCookie(COOKIE_BOXES_DOCUMENTS);
		const cookieVariants = utils.getCookie(COOKIE_PRODUCT_VARIANTS);

		const itemsCookieDocuments = cookieDocuments ? cookieDocuments.split(',') : [];
		const itemsCookieVariants = cookieVariants ? JSON.parse(cookieVariants) : [];

		let length = 0;

		if ( cookieName === COOKIE_BOXES_DOCUMENTS ) {
			let postsWithLanguages = [];

			newValues.forEach( post_id => {
				const checked_languages = document.querySelectorAll(`[id^="document-language-${post_id}"]:checked`);
				if ( checked_languages.length ) {
					checked_languages.forEach( ch => {
						postsWithLanguages.push(ch.value);
					});
				} else {
					postsWithLanguages.push(post_id);
				}
			});

			const uniqCookieDocuments = [...new Set([...itemsCookieDocuments, ...postsWithLanguages])];

			const documentPosts = [];

			uniqCookieDocuments.forEach( row => {
				const columns = row.split('-');
				documentPosts.push(columns[0]);
			});

			const documentPostsUnique = [...new Set(documentPosts)];

			length = documentPostsUnique.length + cookieVariants.size;

			utils.setCookie(COOKIE_BOXES_DOCUMENTS, uniqCookieDocuments.join(','), 1);
		} else if ( cookieName === COOKIE_PRODUCT_VARIANTS ) {
			const updatedVariantsMap = new Map();

			if ( itemsCookieVariants ) {
				itemsCookieVariants.forEach(({ id, quantity }) => {
					updatedVariantsMap.set(id, { id, quantity });
				});
			}

			newValues.forEach(({ id, quantity }) => {
				if (updatedVariantsMap.has(id)) {
					const existing = updatedVariantsMap.get(id);
					updatedVariantsMap.set(id, { id, quantity: existing.quantity + quantity });
				} else {
					updatedVariantsMap.set(id, { id, quantity });
				}
			});

			length = itemsCookieDocuments.length + updatedVariantsMap.size;

			utils.setCookie(COOKIE_PRODUCT_VARIANTS, JSON.stringify([...updatedVariantsMap.values()]), 1);
		}

        this.updateHeaderBoxQuantity(length);
	},

    updateHeaderBoxQuantity(length) {
        document.querySelectorAll('.download-button__quantity').forEach(count => {
            if (length > 0) {
                count.innerHTML = length;
                count.classList.remove('hidden');
            } else {
                count.classList.add('hidden');
            }
        });
    },

	removeFromBox(removeValues, cookieName) {
		const cookieDocuments = utils.getCookie('boxed_documents');
		const cookieVariants = utils.getCookie('product_variants');

		const itemsCookieDocuments = cookieDocuments ? cookieDocuments.split(',') : [];
		const itemsCookieVariants = cookieVariants ? JSON.parse(cookieVariants) : [];

		let length = 0;
		if ( cookieName === 'boxed_documents' ) {
			const cookieDocumentsLeft = itemsCookieDocuments.filter(itemCookieDocument => {
				const found = removeValues.some( removeValue => itemCookieDocument.indexOf(removeValue) !== -1 );
				return !found;
			});

			length = cookieDocumentsLeft.length + itemsCookieVariants.length;

			utils.setCookie('boxed_documents', cookieDocumentsLeft.join(','), 1);
		} else if ( cookieName === 'product_variants' ) {
			const cookieVariantsLeft = itemsCookieVariants.filter(itemCookieVariant => !removeValues.includes(itemCookieVariant.id));

			length = cookieVariantsLeft.length + itemsCookieDocuments.length;

			utils.setCookie('product_variants', JSON.stringify([...cookieVariantsLeft.values()]), 1);
		}

        this.updateHeaderBoxQuantity(length);
    }
}

export default handleAddToBox;
